export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإجراءات"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحرير المعلومات حول المجمع"])}
}